import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

interface StyleProps {
  align: "left" | "right";
}

const useStyles = makeStyles((theme: Theme) => ({
  root: (props: StyleProps) => ({
    float: props.align === "right" ? "left" : "right",
    height: 28,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    aligneItems: "center",
  }),
  icon: {
    width: "20px",
    height: "20px",
    cursor: "pointer",
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    color: theme.palette.gray60.main,
  },
  spacer: {
    float: "right",
    minWidth: 56,
  },
}));

export default useStyles;
